import map from "lodash/map";
import CycleCardCP from "./CycleCardCP";
import { useEffect, useState } from "react";
import submit from "submit-form";
import SvgIcon from "../../../../parts/SvgIcon";
import { useTranslation } from "react-i18next";

const sortByName = (a, b) =>
  (a.name || "").localeCompare(b.name || "", undefined, {
    sensitivity: "base",
  });
const sortByNameDesc = (a, b) =>
  (b.name || "").localeCompare(a.name || "", undefined, {
    sensitivity: "base",
  });
const sortByCreatedDate = (a, b) => {
  const dateA = new Date(a.createdDate || 0).getTime();
  const dateB = new Date(b.createdDate || 0).getTime();
  return dateB - dateA;
};

const SORT_FUNCTIONS = {
  name: sortByName,
  nameDescending: sortByNameDesc,
  createdDate: sortByCreatedDate,
};

const TeamsPrograms = ({ locals }) => {
  const { teamPrograms, query, activeUserToRequest } = locals;
  const { published, draft } = teamPrograms;
  const status = query.status || "published";
  const programs = status === "draft" ? draft : published;
  const sort = query.sort || "createdDate";
  const sortFn = SORT_FUNCTIONS[sort] || sortByCreatedDate;
  const sortedPrograms = [...programs].sort(sortFn);

  const hasDraftedPrograms = draft.length > 0;
  const hasPublishedPrograms = published.length > 0;

  return (
    <section>
      <div
        className={`columns ${status === "draft" ? "draft" : ""}`}
        id="drag-items"
      >
        {sortedPrograms.length > 0 ? (
          map(sortedPrograms, (cycle, cardIndex) => (
            <CycleCardCP
              key={cycle._id}
              cycle={cycle}
              cardIndex={cardIndex}
              isOwnCycle={cycle.owner === activeUserToRequest._id}
            />
          ))
        ) : (
          <TeamsEmptyState
            status={status}
            hasDraftedPrograms={hasDraftedPrograms}
            hasPublishedPrograms={hasPublishedPrograms}
          />
        )}
      </div>
    </section>
  );
};

const TeamsEmptyState = ({
  status,
  hasDraftedPrograms,
  hasPublishedPrograms,
}) => {
  const { t } = useTranslation("coaching-portal");
  const [imageUrl, setImageUrl] = useState(null);

  useEffect(() => {
    const getVideoThumbnail = async () => {
      const { oembed } = await import("@loomhq/loom-embed");
      const videoMeta = await oembed(
        "https://www.loom.com/share/491ae39a80784d00bcad79e0c2c86161"
      );

      if (videoMeta) {
        setImageUrl(videoMeta?.thumbnail_url);
      }
    };

    getVideoThumbnail();
  }, []);

  const openVideoModal = () => {
    submit("/actions/refresh?", {
      method: "GET",
      body: {
        "modal[type]": "watch-loom-video",
        sharedUrl: "491ae39a80784d00bcad79e0c2c86161",
      },
    });
  };

  if (status === "published" && !!hasDraftedPrograms) {
    return (
      <div className="no-teams-section">
        <div className="no-teams-section-card">
          <h3>{t("allTemplates.teamsPrograms.almostReadyTitle")}</h3>

          <p className="p2 py-8 text-center">
            {t("allTemplates.teamsPrograms.almostReadyDescription")}
          </p>
          <a
            role="button"
            className="py-2 px-4"
            data-button-type="primary"
            href="/coaching-portal/store?status=draft&storeType=teams"
          >
            {t("allTemplates.teamsPrograms.goToDraftTeams")}
          </a>
        </div>
      </div>
    );
  }

  if (status !== "published" && !!hasPublishedPrograms) {
    return (
      <div className="no-teams-section">
        <h3 className="pb-4">
          {t("allTemplates.teamsPrograms.noDraftsTitle")}
        </h3>
        <p className="p2 pb-9">
          {t("allTemplates.teamsPrograms.noDraftsSubtitle")}
        </p>
        <a
          role="button"
          data-button-type="primary"
          href={`/actions/refresh/?modal[type]=build-step-one&cycleType=new&isSubscription=true&storeType=teams&fromTemplate=true&tabView=teams-programs-tab&templateView=teams-programs`}
        >
          <img
            alt={t("allTemplates.header.addIconAlt")}
            src="/img/new-icons/add.svg"
          />
          {t("allTemplates.header.addNew")}
        </a>
      </div>
    );
  }

  return (
    <div className="no-teams-section">
      <div className="no-teams-section-card">
        <h3>{t("allTemplates.teamsPrograms.noTeamsTitle")}</h3>

        <div className="w-71 h-full">
          {imageUrl && (
            <SvgIcon
              src="/img/new-icons/play-white.svg"
              classNames="play-icon"
              noFilterOnLight={true}
              onClickFn={openVideoModal}
            />
          )}

          {imageUrl && (
            <img
              className="rounded-lg aspect-video object-cover mb-6 cursor-pointer"
              src={imageUrl}
              alt={t("allTemplates.teamsPrograms.videoAlt")}
              onClick={openVideoModal}
            />
          )}
        </div>

        <a
          target="_blank"
          href="https://msbapp.notion.site/team-programs"
          className="mb-6 text-blue-400 underline"
          rel="noopener"
        >
          {t("allTemplates.teamsPrograms.teamsGuide")}
        </a>

        <h4 className="pb-3">{t("allTemplates.teamsPrograms.tagline")}</h4>

        <p className="p2 pb-8 text-center">
          {t("allTemplates.teamsPrograms.emptyDescription")}
        </p>
        <a
          role="button"
          className="py-2 px-4"
          data-button-type="primary"
          href={`/actions/refresh/?modal[type]=build-step-one&cycleType=new&isSubscription=true&storeType=teams&fromTemplate=true&tabView=teams-programs-tab&templateView=teams-programs`}
        >
          <img
            alt={t("allTemplates.header.addIconAlt")}
            src="/img/new-icons/add.svg"
          />
          {t("allTemplates.teamsPrograms.createFirstTeam")}
        </a>
      </div>
    </div>
  );
};

export default TeamsPrograms;
